import * as React from "react";

import { Headings } from "../../elements/Headings/Headings";
import Tag from "../../elements/Tag/Tag";
import './TagList.scss';

export const TagList = ({ title = '', tags }) => {
    return (
        <div className="tag-list__container">
            <div className="tag-list">
                <div className={'tag-list__header'}>
                    <Headings text={title} type={'h3'}/>
                </div>

                <div className="tag-list__tags">
                    {tags && tags.map((tag, index) => (
                        <div key={tag.key || index} className={tag.color}>
                            <Tag text={tag.text} color={tag?.color} textColor={tag?.textColor} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

